var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ais-instant-search",
    {
      ref: "instantSearch",
      attrs: {
        "search-client": _vm.searchClient,
        "index-name": _vm.index,
        "insights-client": _vm.insightsClient,
        middlewares: _vm.middlewares,
        "search-parameters": { clickAnalytics: true },
      },
    },
    [
      _c("ais-configure", {
        attrs: {
          hitsPerPage: 500,
          distinct: true,
          facetFilters: _vm.facetFilters(),
        },
      }),
      _vm._v(" "),
      _c(
        "wa-page",
        { attrs: { "view-slug": "category-landing" } },
        [
          _c("wa-page-header", { attrs: { slot: "header" }, slot: "header" }),
          _vm._v(" "),
          _vm.category != null && _vm.notFound == false
            ? [
                _c(
                  "main",
                  {
                    staticClass: "app-content",
                    class: `theme-${_vm.colors.color1}`,
                    attrs: { slot: "content", role: "main" },
                    slot: "content",
                  },
                  [
                    _vm.isLoading
                      ? _c("wa-icons-loading")
                      : _c("div", [
                          _c("div", { staticClass: "category-header" }, [
                            _c(
                              "div",
                              { staticClass: "container" },
                              [
                                _c("category-header", {
                                  attrs: {
                                    version: _vm.version,
                                    category: _vm.categoryLabel,
                                    "category-icon": _vm.categoryIcon,
                                    description: _vm.categoryDescription,
                                    "selected-style": _vm.selectedStyle,
                                    "selected-family": _vm.selectedFamily,
                                  },
                                }),
                              ],
                              1
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "container" }, [
                            _c("div", { staticClass: "row roomy" }, [
                              _c(
                                "div",
                                { staticClass: "column-12 padding-y-xl" },
                                [
                                  _vm.isOlderVersion
                                    ? _c("wa-old-version-alert", {
                                        attrs: { subject: "icons" },
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "row roomy align-between align-top margin-top-xl",
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "column-12 margin-bottom-xl tablet:margin-bottom-0 tablet:column-8",
                                        },
                                        [
                                          _c(
                                            "div",
                                            [
                                              _c("icon-pack-selector", {
                                                attrs: {
                                                  "category-icon":
                                                    _vm.categoryIcon,
                                                  "selected-style":
                                                    _vm.params.style,
                                                  "selected-family":
                                                    _vm.params.family,
                                                  "selected-pack":
                                                    _vm.params.pack,
                                                  version: _vm.version,
                                                },
                                                on: {
                                                  selectStyle: _vm.selectStyle,
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value: _vm.isFree,
                                                    expression: "isFree",
                                                  },
                                                ],
                                                staticClass:
                                                  "sr-only with-icon",
                                                attrs: {
                                                  id: "checkbox_free",
                                                  type: "checkbox",
                                                  name: "checkbox_free",
                                                  value: "Show only Free icons",
                                                },
                                                domProps: {
                                                  checked: Array.isArray(
                                                    _vm.isFree
                                                  )
                                                    ? _vm._i(
                                                        _vm.isFree,
                                                        "Show only Free icons"
                                                      ) > -1
                                                    : _vm.isFree,
                                                },
                                                on: {
                                                  change: function ($event) {
                                                    var $$a = _vm.isFree,
                                                      $$el = $event.target,
                                                      $$c = $$el.checked
                                                        ? true
                                                        : false
                                                    if (Array.isArray($$a)) {
                                                      var $$v =
                                                          "Show only Free icons",
                                                        $$i = _vm._i($$a, $$v)
                                                      if ($$el.checked) {
                                                        $$i < 0 &&
                                                          (_vm.isFree =
                                                            $$a.concat([$$v]))
                                                      } else {
                                                        $$i > -1 &&
                                                          (_vm.isFree = $$a
                                                            .slice(0, $$i)
                                                            .concat(
                                                              $$a.slice($$i + 1)
                                                            ))
                                                      }
                                                    } else {
                                                      _vm.isFree = $$c
                                                    }
                                                  },
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "label",
                                                {
                                                  staticClass:
                                                    "icons-facet icons-facet-input margin-0 flex-row size-sm flex-items-baseline",
                                                  staticStyle: {
                                                    padding:
                                                      "var(--spacing-2xs) var(--spacing-sm)",
                                                    cursor: "pointer",
                                                    display: "flex !important",
                                                  },
                                                  attrs: {
                                                    for: "checkbox_free",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "position-relative margin-right-xs",
                                                    },
                                                    [
                                                      _c("font-awesome-icon", {
                                                        staticClass:
                                                          "checked-icon",
                                                        staticStyle: {
                                                          color:
                                                            "var(--category-color-alt)",
                                                        },
                                                        attrs: {
                                                          icon: _vm.$v6.solid
                                                            .faSquareCheck,
                                                          "fixed-width": "",
                                                          size: "lg",
                                                        },
                                                      }),
                                                      _vm._v(" "),
                                                      _c("font-awesome-icon", {
                                                        staticClass:
                                                          "hover-icon",
                                                        attrs: {
                                                          icon: _vm.$v6.regular
                                                            .faSquare,
                                                          "fixed-width": "",
                                                          size: "lg",
                                                        },
                                                      }),
                                                      _vm._v(" "),
                                                      _c("font-awesome-icon", {
                                                        staticClass:
                                                          "unchecked-icon",
                                                        attrs: {
                                                          icon: _vm.$v6.regular
                                                            .faSquare,
                                                          "fixed-width": "",
                                                          size: "lg",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c("span", [
                                                    _vm._v(
                                                      " Show only Free icons "
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "column-12 tablet:column-4 margin-top-4xs",
                                        },
                                        [
                                          _c(
                                            "form",
                                            {
                                              staticClass: "icons-search form",
                                              attrs: {
                                                method: "post",
                                                name: "header_search",
                                              },
                                              on: {
                                                submit: function ($event) {
                                                  $event.preventDefault()
                                                  return _vm.search()
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "with-icon-before",
                                                  staticStyle: {
                                                    "--input-padding":
                                                      "var(--spacing-sm) var(--spacing-xl) var(--spacing-xs) var(--spacing-xl)",
                                                  },
                                                },
                                                [
                                                  _c("font-awesome-icon", {
                                                    staticStyle: {
                                                      "line-height": "1",
                                                      top: "13px",
                                                    },
                                                    attrs: {
                                                      icon: _vm.$v6.solid
                                                        .faSearch,
                                                    },
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass: "sr-only",
                                                      attrs: {
                                                        for: "search_query",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                          Search Icons\n                        "
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("input", {
                                                    ref: "searchQuery",
                                                    staticClass: "rounded",
                                                    attrs: {
                                                      id: "search_query",
                                                      name: "search_query",
                                                      value: "",
                                                      placeholder: `Search icons in ${_vm.categoryLabel}...`,
                                                      type: "text",
                                                    },
                                                    on: {
                                                      focus: function ($event) {
                                                        _vm.searchFieldFocus = true
                                                      },
                                                      blur: function ($event) {
                                                        _vm.searchFieldFocus = false
                                                      },
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "button",
                                                {
                                                  staticClass: "sr-only",
                                                  attrs: { type: "submit" },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                        Search Font Awesome Icons\n                      "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("category-icons", {
                                    ref: "iconList",
                                    attrs: {
                                      "category-label": _vm.categoryLabel,
                                      "selected-icon-id": _vm.selectedIconId,
                                      "selected-style": _vm.params.style,
                                      "selected-family": _vm.params.family,
                                      "is-pro-user": _vm.isProUser,
                                      "free-selected": _vm.isFree,
                                      version: _vm.version,
                                      "search-field-focus":
                                        _vm.searchFieldFocus,
                                    },
                                    on: { toggleIcon: _vm.toggleIcon },
                                  }),
                                  _vm._v(" "),
                                  _c("category-examples", {
                                    attrs: {
                                      category: _vm.category,
                                      "category-label": _vm.categoryLabel,
                                      "category-icon": _vm.categoryIcon,
                                      "selected-family": _vm.selectedFamily,
                                      version: _vm.version,
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "margin-top-3xl",
                                      attrs: { id: "more" },
                                    },
                                    [
                                      _c(
                                        "article",
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "row align-middle margin-bottom-xl",
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "column-12 margin-bottom-sm laptop:column-7 laptop:margin-bottom-0",
                                                },
                                                [
                                                  _c(
                                                    "h3",
                                                    {
                                                      staticClass:
                                                        "h3 text-capitalize",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "Not finding what you need in " +
                                                          _vm._s(
                                                            _vm.categoryLabel
                                                          ) +
                                                          "?"
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "column-12 laptop:column-5 laptop:text-right",
                                                },
                                                [
                                                  _c("p", [
                                                    _vm._v(
                                                      "That's okay, we've got options for that too."
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("icons-supplemental-actions", {
                                            attrs: {
                                              version: _vm.version,
                                              "layout-wide": "",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "article",
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "row align-middle margin-bottom-xl",
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "column-7" },
                                                [
                                                  _c(
                                                    "h3",
                                                    {
                                                      staticClass:
                                                        "h3 text-capitalize margin-0",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "Or try out these other categories…"
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "column-5 text-right",
                                                },
                                                [
                                                  _c(
                                                    "site-link",
                                                    {
                                                      staticClass:
                                                        "button flat with-border margin-bottom-0",
                                                      staticStyle: {
                                                        "--border-color":
                                                          "var(--fa-gravy)",
                                                        "--button-background":
                                                          "transparent",
                                                        "--button-color":
                                                          "var(--fa-navy)",
                                                      },
                                                      attrs: {
                                                        to: {
                                                          name:
                                                            _vm.version === 5
                                                              ? "five.icons.categories"
                                                              : "latest.icons.categories",
                                                        },
                                                      },
                                                      nativeOn: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.$posthog.capture(
                                                            "category_landing:all_categories_link_click",
                                                            {
                                                              category:
                                                                _vm.category,
                                                            }
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                          View All Categories\n                          "
                                                      ),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "display-none tablet:display-inline",
                                                        },
                                                        [
                                                          _c(
                                                            "font-awesome-icon",
                                                            {
                                                              staticClass:
                                                                "margin-left-md",
                                                              attrs: {
                                                                icon: _vm.$v6
                                                                  .solid
                                                                  .faGrid2,
                                                                "fixed-width":
                                                                  "",
                                                                size: "lg",
                                                              },
                                                            }
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("category-suggestions", {
                                            attrs: {
                                              "category-icons":
                                                _vm.categoryIconsList,
                                              "suggestion-count": 6,
                                              "current-category": _vm.category,
                                              color: _vm.colors.color1,
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ]),
                          ]),
                        ]),
                    _vm._v(" "),
                    _c(
                      "section",
                      {
                        staticClass: "wrap-icon-detail",
                        attrs: { id: "iconPreview" },
                      },
                      [
                        _c(
                          "transition",
                          {
                            attrs: {
                              name: "toggle-icon-detail",
                              appear: "",
                              "enter-active-class":
                                "animate__animated animate__faster animate__fadeIn",
                            },
                            on: { "after-leave": _vm.ejectIconPreview },
                          },
                          [
                            _c("modal-icon-detail", {
                              ref: "iconModal",
                              attrs: {
                                "default-styles": _vm.defaultStyles,
                                icon: _vm.icon,
                                "icon-abstract": _vm.iconAbstract,
                                "icon-name": _vm.selectedIconId,
                                index: _vm.index,
                                "is-duotone": _vm.isDuotoneIcon,
                                "is-pro-user": _vm.isProUser,
                                "is-showing": _vm.isShowingIconModal,
                                "selected-from-search": _vm.selectedIcon,
                                styling: _vm.styling,
                                viggo: _vm.viggo,
                              },
                              on: {
                                closeIcon: _vm.closeIcon,
                                nextIcon: function ($event) {
                                  return _vm.$refs.iconList.next()
                                },
                                prevIcon: function ($event) {
                                  return _vm.$refs.iconList.previous()
                                },
                                resetStyles: _vm.resetStyles,
                                selectCategory: _vm.selectCategory,
                                stylingChange: _vm.stylingChange,
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("font-awesome-summary", {
                  attrs: {
                    slot: "sock",
                    "categories-count": _vm.categoriesCount,
                    version: _vm.version,
                  },
                  slot: "sock",
                }),
              ]
            : _c(
                "main",
                {
                  staticClass: "app-content",
                  attrs: { slot: "content", role: "main" },
                  slot: "content",
                },
                [
                  _c("category-not-found", {
                    attrs: {
                      "categories-count": _vm.categoriesCount,
                      category: _vm.category,
                    },
                  }),
                ],
                1
              ),
          _vm._v(" "),
          _c("wa-page-footer", { attrs: { slot: "footer" }, slot: "footer" }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }